module.exports = __webpack_public_path__ + "img/kehu.2ca857b4.png";